module.exports = __webpack_public_path__ + "static/media/pple.73b36f9e.png";